import { ReportHandler } from 'web-vitals';
import { getPerformance } from 'firebase/performance';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Truncate long attribute values
      const safeReporter = (metric: any) => {
        try {
          // Truncate any attribute value longer than 100 characters
          if (metric.attribution && metric.attribution.element) {
            const element = metric.attribution.element as string;
            if (element.length > 100) {
              metric.attribution.element = element.substring(0, 100) + '...';
            }
          }
          onPerfEntry(metric);
        } catch (error) {
          console.warn('Error reporting web vital:', error);
        }
      };

      getCLS(safeReporter);
      getFID(safeReporter);
      getFCP(safeReporter);
      getLCP(safeReporter);
      getTTFB(safeReporter);
    });
  }
};

export default reportWebVitals;
